<template>
<div class="conteudoInterno">
  <div class="boxSeta">
      <div class="setaScrollstatic" style="" 
          :class="{ 
            setaScroll: setaScrollState 
            }"
      >
        <button><span><i class="bottom"></i></span></button>
      </div> 
  </div>
  <header class="headerSec">
    <h2>Cenário em 2018</h2>
    <div class="navSetas">
      <button @click="goBack()" :disabled="clicked"><span><i class="left"></i></span></button>
      <button @click="goNext()" :disabled="clicked"><span><i class="right"></i></span></button>
    </div> 
    <!-- <span></span> -->
  </header>
  <div class="conteudoInternoBox" ref="infoBox">
    <section class="sectionRow" ref="infoscroll">
      <div class="col23ponto5 marginColBottom">
        <span class="linecol32"></span> 
      </div> 
      <div class="col36">
        <ul class="listacen2018">
          <li>Ano de eleições presidenciais no Brasil marcado por grande instabilidade política e econômica.</li>
          <li>Por exigência da lei mais recente de direitos autorais no país, a UBC completou um processo habilitação no Ministério da Cultura e foi oficialmente habilitada para atuação na gestão coletiva de direitos autorais em janeiro.</li>
          <li>O curso Copyright: História, Cultura e Indústria, desenvolvido pela Cisac, foi oferecido em Português e Espanhol através de uma parceria entre SPA e UBC. As três rodadas nestes idiomas atraíram mais de 3.500 alunos. </li>
          <li>A UBC lançou mais uma ferramenta online para seus associados, o fonograma web, que possibilita o cadastro de ISRCs online diretamente pelo Portal do Associado sem a necessidade de instalação de software. Agora os associados podem registrar obras e fonogramas pelo portal.</li>
          <li>Em julho de 2018, foi feita a distribuição do acordo celebrado no final de 2017 com o YouTube, que passou a integrar o calendário normal de distribuição.</li>
        </ul>
      </div>
      <div class="col36">
        <ul class="listacen2018">
          <li>Foram fechados acordos importantes com serviços digitais ao longo de 2018: Amazon Video, Facebook, Google Play Music e Tim Music by Deezer. Outro acordo digno de nota foi com a Associação Brasileira das Empresas Exibidoras Cinematográficas Operadoras de Multiplex (Abraplex).</li>
          <li>O contrato com a principal operadora de TV do país, Globo, foi renovado e passou a englobar as plataformas digitais do grupo Globo: GloboPlay, Telecine Play, Philos TV e outras.</li>
          <li>A UBC lançou seu primeiro relatório sobre a participação das mulheres na música: Por Elas Que Fazem a Música. Um retrato da nossa base de dados com um olhar sobre o gênero que tem o objetivo de levantar a discussão sobre o tema.</li>
          <li>O Prêmio UBC homenageou Erasmo Carlos como o compositor brasileiro de 2018 e criou uma nova categoria, o Troféu Fernando Brant, dado ao advogado João Carlos Müller por sua destacada atuação em defesa dos direitos autorais.</li>
          <li>Em parceria com a APRA, a UBC realizou o SongHubs SP, um acampamento de criação de três dias que reuniu compositores australianos e brasileiros em São Paulo.</li>
        </ul>
      </div>
    </section>
  </div>
</div>
</template>

<script>
export default {
  name: 'Cenario2018',
  props:['clicked'],
  data() {
    return{
      setaScrollState: false,
    }
  },
  destroyed(){  
    this.myStopFunction();
  },
  mounted () {
    this.showSetaScroll();
  },
  methods:{
    showSetaScroll: function(){
      this.refresh = setInterval(() => {
        let alturaTela = window.innerHeight;
        let alturaDiv = this.$refs.infoBox.clientHeight;
        let boxABB = this.$refs["infoscroll"].getBoundingClientRect();
        if(alturaTela - 10 <= alturaDiv && boxABB.top == 148){
          this.setaScrollState = true
        }else{
          this.setaScrollState = false
        }
      }, 1000);
    },
    myStopFunction: function() {
      clearInterval(this.refresh);
    },
    goNext: function(){
      this.$emit("go-next");
    },
    goBack: function(){
      this.$emit("go-back");
    },  
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>


// WEBPACK FOOTER //
// src/components/Cenario2018.vue